import * as React from "react";
import type { ZiggyVariant } from "./ziggy";
import {
  ZIGGY_CHOSEN_KEY,
  ZIGGY_VARIANT_KEY,
  ZiggyVariantContext,
  readStoredZiggy,
  type ZiggyVariantContextValue,
} from "./ziggyContext";

/** Holds the learner's chosen Ziggy look and persists it to localStorage. */
export function ZiggyVariantProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = React.useState(readStoredZiggy);

  const setVariant = React.useCallback((variant: ZiggyVariant) => {
    setState({ variant, chosen: true });
    try {
      window.localStorage.setItem(ZIGGY_VARIANT_KEY, variant);
      window.localStorage.setItem(ZIGGY_CHOSEN_KEY, "1");
    } catch {
      /* best-effort persistence */
    }
  }, []);

  const value = React.useMemo<ZiggyVariantContextValue>(
    () => ({ ...state, setVariant }),
    [state, setVariant],
  );

  return <ZiggyVariantContext.Provider value={value}>{children}</ZiggyVariantContext.Provider>;
}
